import { gql } from "@apollo/client";
import { CONTENT_NODE_FIELDS } from "@/app/graphql/fragments/contentNodeFields";

/**
 * Lightweight context query for UI that only needs selection/mode state.
 * Intentionally excludes expensive computed fields like sizeInPages/sizeInTokens.
 */
export const FETCH_CONTEXT_SELECTION_FOR_CHAT = gql`
    ${CONTENT_NODE_FIELDS}
    query ContextSelectionForChat($chatId: ID!) {
        contextForChat(chatId: $chatId) {
            id
            graphEnabled
            companyContextEnabled
            gptOnlyEnabled
            isLocked
            contentNodes {
                ...ContentNodeFields
            }
            attachments {
                id
                messageId
                fileName
                tokens
                fileSize
                pages
            }
        }
    }
`;


